import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchZohoDeals, fetchZohoDealsCSV } from 'src/services/napi/zohoDeals/fetchZohoDealsData';

const fetchZohoDealsData = async (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
  status?: string;
}) => {
  const { orderBy, orderDirection, page, pageSize, status, search } = params;
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await fetchZohoDeals({
    orderBy: orderBy || 'created',
    orderDirection: orderDirection || '-1',
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id,
    search: search || '',
    status: status || 'All'
  });
  return data;
};

export const fetchZohoDealsCSVData = async () => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await fetchZohoDealsCSV({
    projectId: currentProject._id
  });
  return data;
};

export const useGetZohoDeals = (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
  status?: string;
}) => {
  const { notify } = useNotification();
  const { orderBy, orderDirection, page, pageSize, status, search } = params;

  return useQuery(
    [QueryKey.ZOHO_DEALS, page, pageSize, orderBy, orderDirection, status],
    () =>
      fetchZohoDealsData({
        orderBy,
        orderDirection,
        page,
        pageSize,
        search,
        status
      }),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
